import React from 'react';
import { Dialog, Grid, Box, CircularProgress, Typography } from '@mui/material';
import Loader from '@/shared/components/Loader';
import CommonButton from '@/shared/components/CommonButton';

interface IPreviewModalProps {
  open: boolean;
  onClose: () => void;
  previewLoading: boolean;
  previewVideoUrl: string | null;
  handleDataSubmit: () => void;
  t: (key: string) => string;
  isVideoLoading: boolean;
}

const PreviewModal: React.FC<IPreviewModalProps> = ({
  open,
  onClose,
  previewLoading,
  previewVideoUrl,
  handleDataSubmit,
  t,
  isVideoLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: '560px',
          minHeight: '360px',
          borderRadius: 2,
          boxShadow: 8,
        },
      }}>
      <Grid container p={2} sx={{ minWidth: '560px', minHeight: '360px' }}>
        {previewLoading ? (
          <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
            <Box sx={{ position: 'relative' }}>
              <CircularProgress
                variant="indeterminate"
                size={40}
                sx={{
                  color: 'primary.main',
                }}
              />
            </Box>
            <Typography variant="body2" color="textSecondary">
              {t('pleaseWaitVideoIsGenerating')}
            </Typography>
          </Grid>
        ) : previewVideoUrl ? (
          <>
            <Grid item xs={12}>
              <video
                src={previewVideoUrl}
                controls
                style={{
                  width: '100%',
                  maxHeight: 340,
                  borderRadius: 8,
                  background: 'transparent',
                  objectFit: 'contain',
                }}
              />
            </Grid>
            <Grid item xs={12} mt={2} display="flex" justifyContent="space-between" alignItems="flex-end">
              <CommonButton onClick={onClose} color="error" sx={{ minWidth: 120 }}>
                {t('cancel')}
              </CommonButton>
              {isVideoLoading ? (
                <Loader />
              ) : (
                <CommonButton
                  type="submit"
                  onClick={handleDataSubmit}
                  variant="contained"
                  color="primary"
                  sx={{ minWidth: 120 }}>
                  {t('create')}
                </CommonButton>
              )}
            </Grid>
          </>
        ) : (
          <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
            <Typography color="error">{t('somethingWrong')}</Typography>
          </Grid>
        )}
      </Grid>
    </Dialog>
  );
};

export default PreviewModal;
